const e = { aria_label: "Zoeken", clear: "Transparant", placeholder_article: "", placeholder_header: "Zoek artikelen" }, a = {
  searcher: e
};
export {
  a as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search41.js.map
